<template>
  <v-dialog v-model="dialogLocal" max-width="520px" persistent transition="dialog-bottom-transition">
    <v-card class="rounded-xl overflow-hidden">
      <!-- Header -->
      <v-toolbar color="primary" dark flat dense>
        <v-icon small class="mr-2">mdi-locker</v-icon>
        <v-toolbar-title class="subtitle-1 font-weight-bold">Asignar Artículo a Armario</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon small @click="close">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pt-5 pb-2">
        <!-- Ficha resumen del artículo a asignar -->
        <v-card outlined class="pa-3 mb-5 rounded-lg grey lighten-5">
          <div class="caption font-weight-bold grey--text text--darken-1 mb-1">ARTÍCULO SELECCIONADO</div>
          <div class="body-1 font-weight-bold primary--text">{{ piezaLocal.name }}</div>
          <div class="d-flex align-center mt-1 flex-wrap caption grey--text text--darken-2">
            <span class="mr-3">
              <strong>Ref:</strong> {{ piezaLocal.default_code || 'Sin referencia' }}
            </span>
            <span v-if="piezaLocal.barcode">
              <v-icon x-small class="mr-1">mdi-barcode</v-icon>{{ piezaLocal.barcode }}
            </span>
          </div>
        </v-card>

        <v-form ref="formAsignacion" v-model="valido" lazy-validation>
          <!-- Selector de Cliente -->
          <v-autocomplete
            v-model="clienteSeleccionado"
            :items="clientes"
            item-text="nombre"
            item-value="id_cliente"
            label="Cliente / Empresa"
            placeholder="Selecciona un cliente"
            outlined
            dense
            prepend-inner-icon="mdi-domain"
            :loading="cargandoClientes"
            :rules="[v => !!v || 'Debe seleccionar un cliente']"
            @change="onClienteChange"
            clearable
            class="mb-2"
          ></v-autocomplete>

          <!-- Selector de Armario (dependiente del cliente) -->
          <v-autocomplete
            v-model="armarioSeleccionado"
            :items="armarios"
            item-text="name"
            item-value="id"
            label="Armario de destino"
            :placeholder="!clienteSeleccionado ? 'Primero selecciona un cliente' : 'Selecciona el armario'"
            outlined
            dense
            prepend-inner-icon="mdi-locker"
            :loading="cargandoArmarios"
            :disabled="!clienteSeleccionado || armarios.length === 0"
            :rules="[v => !!v || 'Debe seleccionar un armario']"
            class="mb-2"
            no-data-text="No hay armarios disponibles para este cliente"
          ></v-autocomplete>

          <!-- Cantidad a asignar (Opcional pero muy útil para almacén) -->
          <v-text-field
            v-model.number="cantidad"
            label="Cantidad a asignar"
            type="number"
            min="1"
            outlined
            dense
            prepend-inner-icon="mdi-numeric"
            :rules="[v => (v && v > 0) || 'Debe ser al menos 1']"
          ></v-text-field>
        </v-form>
      </v-card-text>

      <v-card-actions class="pb-5 px-5">
        <v-btn text rounded color="grey darken-1" @click="close">
          Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          depressed
          rounded
          class="px-5 font-weight-bold"
          :disabled="!valido"
          :loading="guardando"
          @click="guardar"
        >
          <v-icon left small>mdi-check</v-icon>
          Asignar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";

export default {
  name: "DialogAsignarArmario",
  props: {
    dialog: Boolean,
    pieza: Object,
  },
  computed:{
    ...mapState(["clientes"]),
  },
  data() {
    return {
      dialogLocal: false,
      valido: false,
      guardando: false,

      clienteSeleccionado: null,
      armarioSeleccionado: null,
      cantidad: 1,

      armarios: [],

      cargandoClientes: false,
      cargandoArmarios: false,

      piezaLocal: {
        id: null,
        name: "",
        default_code: "",
        barcode: "",
      },
    };
  },
  watch: {
    dialog(val) {
      this.dialogLocal = val;
      if (val) {
        this.resetFormulario();
        if (this.pieza) {
          this.piezaLocal = { ...this.pieza };
        }
      }
    },
    dialogLocal(val) {
      if (!val) {
        this.$emit("update:dialog", false);
      }
    },
  },
  methods: {
    resetFormulario() {
      this.clienteSeleccionado = null;
      this.armarioSeleccionado = null;
      this.armarios = [];
      this.cantidad = 1;
      if (this.$refs.formAsignacion) {
        this.$refs.formAsignacion.resetValidation();
      }
    },

    close() {
      this.dialogLocal = false;
      this.$emit("update:dialog", false);
    },

    // Al seleccionar cliente, cargamos sus armarios
    async onClienteChange(clienteId) {
      this.armarioSeleccionado = null;
      this.armarios = [];
      if (!clienteId) return;

      this.cargandoArmarios = true;
      try {
        // Ajusta la URL según tu backend (Node o Django) para traer armarios por cliente
        const res = await axios.get(
          `${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/armarios/by-cliente-id/${clienteId}`
        );
        this.armarios = res.data.armarios || res.data || [];
      } catch (err) {
        console.error("Error al cargar armarios del cliente:", err);
      } finally {
        this.cargandoArmarios = false;
      }
    },

    async guardar() {
      if (!this.$refs.formAsignacion.validate()) return;

      const payload = {
        product_id: this.piezaLocal.id,
        product_name: this.piezaLocal.name,
        default_code: this.piezaLocal.default_code,
        barcode: this.piezaLocal.barcode,
        id_cliente: this.clienteSeleccionado,
        id_armario: this.armarioSeleccionado,
        cantidad: this.cantidad,
      };

      this.$emit("asignar-armario", payload);
    },
  },
};
</script>